import { mainAPI } from "../../api";

import { ApiErrorResponse } from "../../types/api/error";
import { CitiesListRequest, CitiesListResponse } from "../../types/api/cities";

const path = `/geo/${process.env.REACT_APP_API_VERSION}/cities`;

export function fetchCitiesList(params: CitiesListRequest) {
  return mainAPI.get<CitiesListResponse[]>(`${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}
